<script>

import RequestToJoinUConnectCorporateDialog from "../../../common/requestToJoinUConnectCorporateDialog.vue";
import {mapActions} from "vuex";
import headerNav from "../steps/stepsHeader.vue";
import footNav from "../steps/stepsFooter.vue";
import loadingSkeleton from "../../../package/loadingSkeleton.vue";
import packageCard from "./packageCard.vue";
import packageCardLayout from "./packageCardLayout.vue";


export default {
  name: "uConnectSelectPlanDetailsStep",
  components: {packageCardLayout,packageCard,footNav, headerNav, RequestToJoinUConnectCorporateDialog, loadingSkeleton},

  data() {
    return {
      loading: true,
      activeStep: 1,
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },


  },
  methods: {

    ...mapActions("uConnect", ["updateUConnectUserPackageDetails"]),
    goNext() {
      this.step1a = false;
      this.step1b = true;
    },
    stepChanged(step) {
      this.$emit('stepChanged', step);
    },
    selectPackage(subscriptionId, subscriptionPeriod) {

      localStorage.setItem("selectedProductId", subscriptionId);
      localStorage.setItem("subscriptionPeriod", subscriptionPeriod);
      //setting the temp key for Registration key as subscription id from the route restriction
      localStorage.setItem("uConnectRegistrationKey", subscriptionId);
      this.$emit('stepChanged', 2);
      this.$router.push({name: "uConnectSetPasswordStep"});

    },
  }
}
</script>

<template>
      <div class="pricing-container">
<!--        &lt;!&ndash; Step Indicator Row &ndash;&gt;-->
<!--        <el-row type="flex" justify="center">-->
<!--          <el-col :span="24">-->
<!--            <div class="step-indicator">-->
<!--              <div class="step-text">STEP 1 OF 3</div>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row :gutter="20">
            <package-card-layout @selectedPackage="selectPackage"/>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" >
            <span style="font-size: 12px; color: #003333; font-weight: bold; margin-bottom: 10px">* all prices include GST.</span>
          </el-col>
          <el-col :span="24" >
            <span style="font-size: 12px; color: #003333; font-weight: bold; margin-bottom: 10px">* 12 month subscription term.</span>
          </el-col>
        </el-row>
      </div>
</template>

<style scoped lang="css">

.pricing-container {
  padding: 20px;
  text-align: justify;
}

.step-indicator {
  margin-bottom: 24px;
}

.step-text {
  font-size: 14px;
  color: #606266;
  letter-spacing: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/selectPackage/uConnectSelectPlanDetailsStep.vue